import { render, staticRenderFns } from "./pendidikan_formal.vue?vue&type=template&id=3401baa2&"
import script from "./pendidikan_formal.vue?vue&type=script&lang=js&"
export * from "./pendidikan_formal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports